import { IQuestion } from '../pages/task/types';

export const getUnansweredQuestion = (questions: IQuestion[]): number => {
  const index = questions.findIndex(({ answer }) =>
    Array.isArray(answer) ? answer.length <= 0 : !answer
  );

  return index !== -1 ? index : 0;
};
